// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { useParams } from "react-router-dom";
// import { useMediaQuery } from "react-responsive";
// import TextHeader from "./TextHeader";
// import { API_ROOT , webPath } from "../../apiconfig";

// const sectionsLatest = [
//   { title: "News", key: "newsData" },
//   { title: "QuickBytes", key: "quickByteData" },
// ];

// const sectionsLeadership = [
//   { title: "Podcasts", key: "podcastData" },
//   { title: "Featured Interview", key: "inteviewData" },
//   { title: "Guest Posts", key: "guestPostData" },
// ];

// const sectionsFeatures = [
//   { title: "Articles", key: "articleData" },
//   // { title: "Future Ready", key: "futureReadyData" },
//   { title: "Learning Center", key: "learningData" },
// ];

// const DropComp = React.memo(({ className, section, handleSectionClick, maxItems }) => {
//   const { cat_slug } = useParams();
//   const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

//   const [headerData, setHeaderData] = useState({
//     latest: {},
//     leadership: {},
//     features: {},
//   });

//   const [loading, setLoading] = useState(true); 
//   const [error, setError] = useState(null);
//   const [activeSection, setActiveSection] = useState(section);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [latestResponse, leadershipResponse, featuresResponse] = await Promise.all([
//           fetch(`${API_ROOT}/api/post/latestPost`),
//           fetch(`${API_ROOT}/api/post/leadership`),
//           fetch(`${API_ROOT}/api/post/featured`),
//         ]);
//         const [latestData, leadershipData, featuresData] = await Promise.all([
//           latestResponse.json(),
//           leadershipResponse.json(),
//           featuresResponse.json(),
//         ]);

//         setHeaderData({ latest: latestData, leadership: leadershipData, features: featuresData });
//       } catch (error) {
    
//         setError("Error fetching data");
//       } finally {
//         setLoading(false); 
//       }
//     };
//     fetchData();
//   }, []);

//   const renderSection = useCallback((sectionData, sections) => {
//     return sections.map((section, sectionIndex) => {
//       const sectionUrl = `/topic/${sectionData[section.key]?.[0]?.cat_slug || cat_slug}`;
//       // const columnClass = activeSection === "Latest" ? "col-md-6" : "col-md-4";
//         const columnClass =
//           activeSection === "Latest" || activeSection === "Features"
//             ? "col-md-6"
//             : "col-md-4";
//       const sectionClass = isMobile ? "col-12 col-6" : `col-12 ${columnClass} section-line`;

//       return (
//         <div key={sectionIndex} className={sectionClass}>
//           {isMobile ? (
//             <>
//               <a
//                 href={sectionUrl}
//                 style={{ textDecoration: "none", color: "black" }}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   window.location.href = sectionUrl;
//                 }}
//               >
//                 <p className="section-title pt-1">{section.title}</p>
//               </a>
//               <p className="see-more mt-2 mb-2" style={{ display: "none" }}>
//                 <a
//                   className="latest-anchor"
//                   style={{ textDecoration: "none", color: "black" }}
//                   href={sectionUrl}
//                 >
//                   See More
//                 </a>
//               </p>
//             </>
//           ) : (
//             <>
//               <p className="section-title mt-1">{section.title}</p>
//               {sectionData[section.key]?.slice(0, maxItems).map((x, i) => (
//                 <React.Fragment key={i}>
//                   <a
//                     href={`/${x.cat_slug}/${x.post_name}`}
//                     style={{ textDecoration: "none", color: "black" }}
//                   >
//                     <TextHeader
//                       alt={x.post_name}
//                       headerImg={`${webPath}${x.banner_img}?width=300`}
//                       headerText={x.post_title}
//                       headerDesc={x.post_author}
//                       post_date={x?.post_updated_date || x?.post_date}
//                       headerDescClass="header-desc"
//                     />
//                   </a>
//                   <p className="mt-2 section-line"></p>
//                 </React.Fragment>
//               ))}
//               <p className="see-more mt-2 mb-2">
//                 <a
//                   className="latest-anchor"
//                   style={{ textDecoration: "none", color: "black" }}
//                   href={sectionUrl}
//                 >
//                   See More
//                 </a>
//               </p>
//             </>
//           )}
//         </div>
//       );
//     });
//   }, [maxItems, cat_slug, isMobile, activeSection]);

//   const renderedSections = useMemo(() => {
//     if (loading) {
//       return null; 
//     }

//     if (error) {
//       return <p style={{ color: 'red' }}>Error: {error}</p>; 
//     }

//     switch (section) {
//       case "Latest":
//         return renderSection(headerData.latest, sectionsLatest);
//       case "Leadership":
//         return renderSection(headerData.leadership, sectionsLeadership);
//       case "Features":
//         return renderSection(headerData.features, sectionsFeatures);
//       default:
//         return null;
//     }
//   }, [headerData, section, renderSection, loading, error]);

//   useEffect(() => {
//     setActiveSection(section);
//   }, [section]);

//   return (
//     <div className={`container LatestData ${className}`}>
//       <div className="row">
//         {renderedSections}
//       </div>
//     </div>
//   );
// });

// export default DropComp;


import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import TextHeader from "./TextHeader";
import { API_ROOT, webPath } from "../../apiconfig";

const sectionsLatest = [
  { title: "News", key: "newsData" },
  // { title: "QuickBytes", key: "quickByteData" },
];

const sectionsLeadership = [
  { title: "Podcasts", key: "podcastData" },
  { title: "Featured Interview", key: "inteviewData" },
  { title: "Guest Posts", key: "guestPostData" },
];

const sectionsFeatures = [
  { title: "Articles", key: "articleData" },
  // { title: "Future Ready", key: "futureReadyData" },
  { title: "Learning Center", key: "learningData" },
];

const DropComp = React.memo(({ className, section, handleSectionClick, maxItems }) => {
  const { cat_slug } = useParams();

      // ----- Break‑point detection -----
    const isMobile   = useMediaQuery({ query: "(max-width: 767px)" });
    const isLte1024  = useMediaQuery({ query: "(max-width: 1024px)" });
    const isLte768   = useMediaQuery({ query: "(max-width: 768px)" });

    // ----- Compute the maxWidth for the Leadership section -----
    const leadershipMaxWidth = useMemo(() => {
      if (isLte768)  return "650px";   // ≤ 768 px
      // if (isLte1024) return "800px";  
      // return "1000px";                  // > 1024 px (fallback / desktop)
    }, [isLte768, isLte1024]);


  const [headerData, setHeaderData] = useState({
    latest: {},
    leadership: {},
    features: {},
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeSection, setActiveSection] = useState(section);

  // -----------------------------------------------------------------
  // Data fetching (unchanged)
  // -----------------------------------------------------------------
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [latestResp, leadershipResp, featuresResp] = await Promise.all([
          fetch(`${API_ROOT}/api/post/latestPost`),
          fetch(`${API_ROOT}/api/post/leadership`),
          fetch(`${API_ROOT}/api/post/featured`),
        ]);
        const [latestData, leadershipData, featuresData] = await Promise.all([
          latestResp.json(),
          leadershipResp.json(),
          featuresResp.json(),
        ]);

        setHeaderData({ latest: latestData, leadership: leadershipData, features: featuresData });
      } catch (err) {
        setError("Error fetching data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // -----------------------------------------------------------------
  // Render a single section (Leadership gets an extra class)
  // -----------------------------------------------------------------
  const renderSection = useCallback(
    (sectionData, sections) => {
      return sections.map((sectionObj, sectionIndex) => {
        const sectionUrl = `/topic/${sectionData[sectionObj.key]?.[0]?.cat_slug || cat_slug}`;

        // Layout logic (unchanged)
const columnClass =
  activeSection === "Latest"
    ? "col-12"
    : activeSection === "Features"
    ? "col-md-6"
    : "col-md-4";

const sectionClass = isMobile
  ? "col-12"
  : `${columnClass} section-line`;
const latestExtraCls = activeSection === "Latest" ? "latest-item" : "";
        // ---- NEW: add leadership‑item class when we are in the Leadership tab ----
        const leadershipExtraCls = activeSection === "Leadership" ? "leadership-item" : "";
        // -------------------------------------------------------------------------

        return (
          <div
            key={sectionIndex}
            className={`${sectionClass} ${latestExtraCls} ${leadershipExtraCls}`}
          >
            {isMobile ? (
              <>
                <a
                  href={sectionUrl}
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = sectionUrl;
                  }}
                >
                  <p className="section-title pt-1">{sectionObj.title}</p>
                </a>
                <p className="see-more mt-2 mb-2" style={{ display: "none" }}>
                  <a
                    className="latest-anchor"
                    style={{ textDecoration: "none", color: "black" }}
                    href={sectionUrl}
                  >
                    See More
                  </a>
                </p>
              </>
            ) : (
              <>
                <p className="section-title mt-1">{sectionObj.title}</p>
                {sectionData[sectionObj.key]
                  ?.slice(0, maxItems)
                  .map((x, i) => (
                    <React.Fragment key={i}>
                      <a
                        href={`/${x.cat_slug}/${x.post_name}`}
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        <TextHeader
                          alt={x.post_name}
                          headerImg={`${webPath}${x.banner_img}?width=300`}
                          headerText={x.post_title}
                          headerDesc={x.post_author}
                          post_date={x?.post_updated_date || x?.post_date}
                          headerDescClass="header-desc"
                        />
                      </a>
                      <p className="mt-2 section-line"></p>
                    </React.Fragment>
                  ))}
                <p className="see-more mt-2 mb-2">
                  <a
                    className="latest-anchor"
                    style={{ textDecoration: "none", color: "black" }}
                    href={sectionUrl}
                  >
                    See More
                  </a>
                </p>
              </>
            )}
          </div>
        );
      });
    },
    [maxItems, cat_slug, isMobile, activeSection]
  );

  // -----------------------------------------------------------------
  // Memoized rendered output
  // -----------------------------------------------------------------
  const renderedSections = useMemo(() => {
    if (loading) return null;
    if (error) return <p style={{ color: "red" }}>Error: {error}</p>;

    switch (section) {
      case "Latest":
        return renderSection(headerData.latest, sectionsLatest);
      case "Leadership":
        return renderSection(headerData.leadership, sectionsLeadership);
      case "Features":
        return renderSection(headerData.features, sectionsFeatures);
      default:
        return null;
    }
  }, [headerData, section, renderSection, loading, error]);

  // Keep activeSection in sync with prop (unchanged)
  useEffect(() => {
    setActiveSection(section);
  }, [section]);

  return (
  <div
  className={`container LatestData ${className} ${
    activeSection === "Latest" ? "latest-container" : ""
  }`}
>
      <div className="row">{renderedSections}</div>
    </div>
  );
});

export default DropComp;